export const forEachAsync = async (array: any[], callback: ([x]: any) => any) =>
  Promise.all(
    array.map((element) => {
      return new Promise((resolve) => {
        const result = callback(element);
        resolve(result);
      });
    })
  );
